import React from 'react';
import { Box, Button, Menu, MenuItem, IconButton, Chip } from '@mui/material';
import { Language as LanguageIcon, Settings as SettingsIcon } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme, useMediaQuery } from '@mui/material';

const LanguageSwitcher = ({ variant = 'menu', useSettingsIcon = false }) => {
  const { language, changeLanguage, languages } = useLanguage();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const IconComponent = useSettingsIcon ? SettingsIcon : LanguageIcon;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    handleClose();
  };

  const currentLanguage = languages.find((lang) => lang.code === language);

  if (variant === 'chips') {
    return (
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap', alignItems: 'center' }}>
        {languages.map((lang) => (
          <Chip
            key={lang.code}
            label={lang.nativeName}
            onClick={() => changeLanguage(lang.code)}
            color={language === lang.code ? 'primary' : 'default'}
            size="small"
            sx={{
              fontWeight: language === lang.code ? 'bold' : 'normal',
              cursor: 'pointer',
              fontSize: '0.7rem',
              height: '24px',
              '&:hover': {
                backgroundColor: language === lang.code 
                  ? undefined 
                  : 'rgba(0, 0, 0, 0.08)',
              },
            }}
          />
        ))}
      </Box>
    );
  }

  return (
    <>
      {isMobile ? (
        <IconButton
          onClick={handleClick}
          sx={{
            color: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
          }}
        >
          <IconComponent />
        </IconButton>
      ) : (
        <Button
          onClick={handleClick}
          startIcon={<IconComponent />}
          sx={{
            color: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
            textTransform: 'none',
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
          }}
        >
          {currentLanguage?.nativeName || 'English'}
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={language === lang.code}
            sx={{
              fontWeight: language === lang.code ? 'bold' : 'normal',
            }}
          >
            {lang.nativeName} ({lang.name})
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;


